<template>
  <div>
    <FaqPage />
  </div>
</template>

<script>
import FaqPage from '../components/FaqPage';

export default {
  name: 'PlatformFaq',
  components: {
    FaqPage,
  },
};
</script>
